export default {
	account:		JSON.parse(localStorage.getItem('account')),
	environment: 	localStorage.getItem('environment'),
	token: 			localStorage.getItem('token'),
	permissions: 	JSON.parse(localStorage.getItem('permissions'))
}